import { useEffect, useState } from 'react';
import { Form } from 'react-bootstrap';
import { BrowserRouter, useHistory, useLocation } from 'react-router-dom';
import { isArray } from 'lodash';
import PropTypes from 'prop-types';
import pluralize from 'pluralize';
import qs from 'qs';
import CardSkeleton from '../card-skeleton';
import EventCard from '../event-card';
import { useEventFilter, useMonths } from './api';

const EventFilterKernel = ({ title }) => {
  const location = useLocation();
  const history = useHistory();

  const getMonthValueFromUrl = () => {
    const { search } = location;
    const searchParams = new URLSearchParams(search);
    const monthFromSearch = searchParams.get('month');
    return monthFromSearch || '0';
  };

  const [selectedMonth, setSelectedMonth] = useState(getMonthValueFromUrl());
  const [fetchedEvents, status, setMonth] = useEventFilter();
  const [months] = useMonths();

  useEffect(() => {
    const month = getMonthValueFromUrl();
    setSelectedMonth(month);
    setMonth(month);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location]);

  const handleSelectChange = (event) => {
    const month = event.target.value;
    setSelectedMonth(month);
    const searchParamsString = qs.stringify({ month });
    history.push({
      pathname: location.pathname,
      search: searchParamsString,
    });
  };

  return (
    <div>
      {/* Title & Filters */}
      <div className="row">
        <div className="col mb-5">
          <h2>{title}</h2>
        </div>
        <div className="col-sm-12 col-md-6 col-lg-4 mb-5">
          <div className="d-flex flex-column flex-md-row align-items-md-center">
            <div className="fw-bold text-nowrap mb-1 mb-md-0">
              View by month
            </div>

            <Form.Select
              aria-label="Select events by month"
              className="ms-md-4"
              value={selectedMonth}
              onChange={handleSelectChange}
            >
              <option value="0">Viewing all</option>
              {months.map((monthObject, key) => (
                <option
                  value={key + 1}
                  key={monthObject.month}
                  disabled={monthObject.eventCount === 0}
                >
                  {`${monthObject.month} (${pluralize(
                    'event',
                    monthObject.eventCount,
                    true
                  )})`}
                </option>
              ))}
            </Form.Select>
          </div>
        </div>
      </div>

      {/* Cards */}
      <ul className="row gy-5">
        {status === 'succeed' &&
          isArray(fetchedEvents) &&
          fetchedEvents.map((entry) => (
            <li className="col-12 col-sm-6 col-md-4" key={entry.url}>
              {/* eslint-disable-next-line react/jsx-props-no-spreading */}
              <EventCard {...entry} />
            </li>
          ))}

        {status === 'loading' &&
          [...Array(6)].map((e, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <div className="col-12 col-sm-6 col-md-4" key={index}>
              <CardSkeleton />
            </div>
          ))}
      </ul>
    </div>
  );
};

const EventFilter = (props) => (
  <BrowserRouter>
    {/* eslint-disable-next-line react/jsx-props-no-spreading */}
    <EventFilterKernel {...props} />
  </BrowserRouter>
);

export { EventFilter, EventFilterKernel };

EventFilterKernel.propTypes = {
  title: PropTypes.string,
};
